import {Button, ButtonProps} from '@chakra-ui/react'
import {LuListFilter} from 'react-icons/lu'

interface Props extends ButtonProps {
  isApplied: boolean
  hideIcon?: boolean
}

export function FilterButton({children, isApplied, hideIcon, ...props}: Props) {
  return (
    <Button variant="subtle" colorPalette={isApplied ? 'cyan' : undefined} {...props}>
      {children}
      {!hideIcon && <LuListFilter />}
    </Button>
  )
}
